import { Component } from '@angular/core';
import { WhitelistUser } from '../../models/whitelist-user.model';
import { WhitelistService } from '../../services/whitelist.service';
import { PaginatedWhitelistUser } from '../../interfaces/paginated-whitelist-user.interface';
import { generatePagination } from '../../utils/pagination.utils';

@Component({
  selector: 'app-whitelist-users',
  standalone: false,
  templateUrl: './whitelist-users.component.html',
  styleUrl: './whitelist-users.component.css'
})
export class WhitelistUsersComponent {
  whitelistUsers: WhitelistUser[] = [];
  nextPageUrl: string | null = null;
  previousPageUrl: string | null = null;
  currentPage = 1;
  totalPages = 1;
  pageNumbers: any = [];
  searchQuery: string = '';
  submitted = false;

  constructor(
    private whitelistService: WhitelistService,
  ) {}

  ngOnInit() {
    this.loadWhitelistUsers(this.currentPage);
  }

  reset() {
    this.whitelistUsers = [];
    this.nextPageUrl = null;
    this.previousPageUrl = null;
    this.currentPage = 1;
    this.totalPages = 1;
    this.pageNumbers = [];
  }

  loadWhitelistUsers(page: number) {
    this.reset();
    this.submitted = true;

    this.whitelistService.getWhitelistUsers(page, this.searchQuery).subscribe(
      (response: PaginatedWhitelistUser) => {
        this.whitelistUsers = response.results;
        this.nextPageUrl = response.next;
        this.previousPageUrl = response.previous;
        this.currentPage = page;

        const itemsPerPage = 20;
        this.totalPages = Math.ceil(response.count / itemsPerPage);
        this.pageNumbers = generatePagination(this.currentPage, this.totalPages);
        this.submitted = false;
      }
    );
  }

  goToNextPage() {
    if (this.nextPageUrl) {
      const nextPage = this.getPageNumber(this.nextPageUrl);
      this.loadWhitelistUsers(nextPage);
    }
  }

  goToPreviousPage() {
    if (this.previousPageUrl) {
      const prevPage = this.getPageNumber(this.previousPageUrl);
      this.loadWhitelistUsers(prevPage);
    }
  }

  private getPageNumber(url: string): number {
    if (!url) return 1; // fallback if url is null

    const queryString = url.split('?')[1]; // get everything after "?"
    if (!queryString) return 1;

    const params = new URLSearchParams(queryString);
    const page = params.get('page');

    return page ? Number(page) : 1;
  }

  onSearchChange() {
    this.loadWhitelistUsers(this.currentPage)
  }

  isAddUserModalOpen = false;
  newUserEmail: string = '';

  openAddUserModal() {
    this.isAddUserModalOpen = true;
  }

  closeAddUserModal() {
    this.isAddUserModalOpen = false;
    this.newUserEmail = ''; // Clear the input field
  }

  addWhitelistUser() {
    if (this.newUserEmail) {
      this.whitelistService.addWhitelistUser(this.newUserEmail).subscribe(
        () => {
          this.loadWhitelistUsers(this.currentPage);
          this.closeAddUserModal();
        },
        error => {
          console.error('Error adding whitelist user:', error);
          // Optionally, show an error message to the user
        }
      );
    }
  }

  deleteWhitelistUser(id: string) {
    if (window.confirm('Are you sure you want to delete this whitelisted user?')) {
      this.whitelistService.deleteWhitelistUser(id).subscribe(
        () => {
          this.loadWhitelistUsers(this.currentPage);
        },
        error => {
          console.error('Error deleting whitelist user:', error);
          // Optionally, show an error message to the user
        }
      );
    }
  }
}
